import Cookies from 'js-cookie'
import config from './config'
const { cookieExpires } = config
export const TOKEN_KEY = 'token'
export const BASE_USER_MSG_KEY = 'msg'

export default {
  setToken: token => {
    Cookies.set(TOKEN_KEY, token, {
      // token在Cookie中存储的天数，默认1天
      expires: cookieExpires || 7
    })
  },
  getToken: () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) return token
    else return null
  },
  setUserMsg: msg => {
    Cookies.set(BASE_USER_MSG_KEY, msg, {
      expires: cookieExpires || 7
    })
  },
  getUserMsg: () => {
    const token = Cookies.get(BASE_USER_MSG_KEY)
    if (token) return token
    else return null
  },
  clearToken: () => {
    Cookies.remove(TOKEN_KEY)
    Cookies.remove(BASE_USER_MSG_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/cookie.js